// src/pages/servicos/ordensServico/OrdemServicoAcaoModal.js
import React, { useEffect, useState } from 'react';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import Input from '../../../components/input/Input';
import { MEIOS_APROVACAO_OS } from '../../../models/servicos/OrdemServico';
const OrdemServicoAcaoModal = ({
  show,
  tipo,
  onHide,
  onConfirm
}) => {
  const [dados, setDados] = useState({
    motivo: '',
    nomePessoa: '',
    meio: 3,
    observacao: '',
    aprovacaoParcial: false
  });
  useEffect(() => {
    if (show) setDados({
      motivo: '',
      nomePessoa: '',
      meio: 3,
      observacao: '',
      aprovacaoParcial: false
    });
  }, [show, tipo]);
  const aprovacao = tipo === 'aprovar';
  const reabertura = tipo === 'reabrir';
  return <ModalContainer
show={show}
largura="560px">
<ModalHeader>
<h5>{aprovacao ? 'Registrar aprovação' : reabertura ? 'Reabrir OS' : 'Confirmar alteração da OS'}</h5>
<button
className="btn-close"
onClick={onHide} />
</ModalHeader>
<ModalBody>
{aprovacao ? <>
<Input
label="Aprovado por"
value={dados.nomePessoa}
size="100%"
onChange={e => setDados({
          ...dados,
          nomePessoa: e.target.value
        })} />
<label className="form-label mt-2">Meio de aprovação</label>
<select
className="form-select"
value={dados.meio}
onChange={e => setDados({
          ...dados,
          meio: Number(e.target.value)
        })}>
{Object.entries(MEIOS_APROVACAO_OS).map(([id, nome]) => <option
key={id}
value={id}>
{nome}
</option>)}
</select>
<Input
label="Observação"
value={dados.observacao}
rows={3}
size="100%"
onChange={e => setDados({
          ...dados,
          observacao: e.target.value
        })} />
</> : <>
{reabertura && <p className="text-muted mb-2">
  A OS voltará para Em execução e poderá receber alterações nos produtos e serviços.
</p>}
<Input
label={reabertura ? 'Motivo da reabertura' : 'Motivo/observação'}
value={dados.motivo}
rows={3}
size="100%"
onChange={e => setDados({
        ...dados,
        motivo: e.target.value
      })} />
</>}
</ModalBody>
<ModalFooter>
<button
className="btn btn-secondary"
onClick={onHide}>
Voltar
</button>
<button
className="btn btn-primary"
disabled={reabertura && !dados.motivo.trim()}
onClick={() => onConfirm(dados)}>
Confirmar
</button>
</ModalFooter>
</ModalContainer>;
};
export default OrdemServicoAcaoModal;
